export default "/images/vendor/flag-icon-css/flags/4x3/io.svg?a7c201eabf62f13fe1d87fee941671a5";